<template>
    <div :class="['result-type-'+fields.type_id, 'result-file-'+fileFormat.toLowerCase()]" :id="id"
         class="result result-download">
        <div class="row">
            <div class="col-md-3">
                <div :class="{'no-thumbnail':!hasThumbnail}" class="result-thumbnail">
                    <figure>
                        <img :src="thumbnail" alt="" loading="lazy">
                    </figure>
                </div>
            </div>
            <div class="col-md-4 col-lg-5">
                <div class="result-info">
                    <div class="result-title" v-html="fields.title">

                    </div>
                    <p class="result-description" v-html="fields.description">

                    </p>
                    <div class="result-locale-info alert alert-info" v-if="!isLanguageAvailable()">
                        <i class="glyphicon glyphicon-info-sign"></i>
                        {{$t("service_download.result.lang_not_available")}}
                    </div>



                    <div class="file-categories">
                        <ul>
                            <li @click="setFilter('categories',ids)" class="badge"
                                v-for="(ids,category) in fileCategories">
                                {{category}}
                            </li>
                        </ul>
                    </div>
                    <div class="result-alias">
                        {{fields.alias}}
                    </div>

                    <div class="result-version-info alert alert-info mb-x" v-if="isOtherVersionAvailable()">
                      <i class="glyphicon glyphicon-info-sign"></i>
                      <span v-html="$t('service_download.result.version_info',{email:'<a href=\'mailto:service@siegenia.com\'>service@siegenia.com</a>'})"></span>
                    </div>

                </div>
            </div>
            <div class="col-md-5 col-lg-4">
                <div class="result-actions">

                    <div class="file-download result-action">
                        <div class="file-download-info">
                            <a :href="fields.url" class="action action-download" target="_blank">
                                <span class="result-filetype">{{fileFormat}}</span><span
                                    class="result-filesize"
                                    v-if="fields.size > 0">{{fields.size | prettyBytes}}</span><span
                                    class="result-language"
                                    v-show="!showLanguageSelection">{{fields.lang | uppercase }}</span>
                            </a>
                        </div>
                        <div class="dropdown file-action action-download" v-show="showLanguageSelection">
                            <button class="btn btn-flat dropdown-toggle btn-sm" data-toggle="dropdown"
                                    type="button"><i class="icon icon-locale"></i>
                                <span class="caret"></span></button>
                            <ul class="dropdown-menu">
                                <li v-for="lang in existing_languages"><a :href="openUrl(lang)"
                                                                          class="action action-download"
                                                                          target="_blank"
                                ><i :class="['icon-flag-'+lang]"
                                    class="icon icon-flag"></i><span>{{lang|uppercase}}</span></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="file-preview result-action" v-if="fields.preview_url">
                        <div class="file-preview-info">
                            <a :href="fields.preview_url" class="action action-prevew" target="_blank">
                                <span class="preview-type">{{$t("service_download.result.preview_type_catalog")}}</span><span
                                    class="preview-language">{{fields.lang | uppercase}}</span>
                            </a>
                        </div>
                        <div class="dropdown preview-action action-preview" v-show="showLanguageSelection">
                            <button class="btn btn-flat dropdown-toggle btn-sm" data-toggle="dropdown"
                                    type="button"><i class="icon icon-locale"></i>
                                <span class="caret"></span></button>

                            <ul class="dropdown-menu">
                                <li v-for="lang in existing_languages"><a :href="openUrl(lang,'preview')"
                                                                          class="action action-download"
                                                                          target="_blank"
                                ><i :class="['icon-flag-'+lang]"
                                    class="icon icon-flag"></i><span>{{lang|uppercase}}</span></a>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: "DownloadResultFile",
        props: ['result'],
        data: function () {
            return {
                baseUrl: process.env.VUE_APP_API_BASE,
                fields: {},
                id: null
            }
        },
        computed: {
            date() {
                if (typeof this.fields._date_ == 'number') {
                    return new Date(this.fields._date_ * 1000);
                } else {
                    if (typeof this.fields._date_ == 'string') {
                        return new Date(parseInt(this.fields._date_) * 1000);
                    }
                }
                return this.fields._date_;
            },
            isInternational() {
                return this.fields.existing_languages.indexOf('int') >= 0;
            },
            isLanguageUnspecific() {
                return this.fields.existing_languages.indexOf('nn') >= 0;
            },
            existing_languages() {
                return [...this.fields.existing_languages].filter(i => i !== 'nn' || i !== 'int').sort();
            },
            showLanguageSelection() {
                if (this.isLanguageUnspecific) {
                    return false;
                }
                return true;
            },
            fileCategories() {
                let filter = this.$options.filters.category;
                let cat = {};

                let cat_id = [].concat(this.fields.level_0, this.fields.level_1, this.fields.level_2, this.fields.level_3, this.fields.level_4).filter((i) => i);
                for (let i = 0; i < cat_id.length; i++) {
                    let name = filter(cat_id[i]);

                    if (!name)
                        continue;

                    if (!cat[name]) {
                        cat[name] = [];
                    }

                    cat[name].push(cat_id[i]);
                }
                return cat;
            },
            fileFormat() {
                if (this.fields.mimetype)
                    return this.fields.mimetype.split('/').pop().toUpperCase();
                return "";
            },
            thumbnail() {
                if (this.hasThumbnail) {
                    return this.baseUrl + "/api/service/thumbnail" + this.fields.thumbnail;

                }
                return this.baseUrl + "/siauv4/bootstrap/assets/img/icon_file_" + this.fileFormat.toLowerCase()+".svg";
            },
            hasThumbnail(){
                return this.fields.thumbnail;
            }

        },
        methods: {
            openUrl($lang, $type) {
                //if (!this.result.languages[$lang]) {
                return this.baseUrl + "/api/service/file/" + this.result.id + "?locale=" + $lang + ($type ? "&type=" + $type : "");
                //}

                // if ($type !== 'preview')
                //     return this.result.languages[$lang].fields.url;
                // return this.result.languages[$lang].fields.preview_url;
            },
            mapFields() {

            },
            isLanguageAvailable() {
                if (this.result.fields.existing_languages && this.result.fields.existing_languages.indexOf(window.locale) >= 0)
                    return true;

                if (this.isLanguageUnspecific)
                    return true;

                return false;
            },
            isOtherVersionAvailable(){
              let showVersions = [
                'assembly_instructions',
                'operations_manual',
                'hardware_info',
                'installation',
                'maintenance',
              ];

              let valid = false;
              for (let i in showVersions) {
                  if(this.fields.type_id.indexOf(showVersions[i]) >= 0){
                    valid = true; break;
                  }
              }

              if(!valid)
                return;

              let version = this.fields.version;
              if(Number.isNaN(version))
                  return false;

              return Number.parseInt(version) > 0;
            }
        },
        watch: {
            result() {
                //this.mapFields()
                this.id = this.result.id;
                this.fields = this.result.fields;
            }
        },
        created: function () {
            this.id = this.result.id;
            this.fields = this.result.fields;
        }
    }
</script>

<style lang="less">


    .result-alias {
        font-size: 12px;
        color: #666;
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>
